// SplashScreen.js
// import React from "react";
// import DRI from "../assets/Dr.Interior X Irukkai.png";
// import { Grid } from "@mui/material";

// function SplashScreen() {
//   return (
//     <Grid
//       container
//       justifyContent="center"
//       alignItems="center"
//       style={{ height: "100vh" }} // Full viewport height
//     >
//       <Grid item>
//         <img
//           src={DRI}
//           alt="DRI_Irukkai_Collab"
//           style={{ maxWidth: "100%", maxHeight: "100%" }}
//         />
//       </Grid>
//     </Grid>
//   );
// }

// export default SplashScreen;

import React from "react";
import DRI from "../assets/Dr.Interior X Irukkai.png";
import { Grid } from "@mui/material";

function SplashScreen() {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ height: "100vh" }}
    >
      <Grid item>
        <img
          src={DRI}
          alt="DRI_Irukkai_Collab"
          style={{ maxWidth: "100%", maxHeight: "100%" }}
        />
      </Grid>
    </Grid>
  );
}

export default SplashScreen;
